/**
 * @file index.tsx
 *
 * @fileoverview Renders the setup for Google Leaderboard Banner Ad script.
 */
import Script from 'next/script';
import AlignedCenter from '~/vcl/atoms/06-layout/01-alignment/01-align-center';
import React from 'react';
import styles from './AdnuntiusLeaderboardBannerAd.module.scss';

interface AdnuntiusLeaderboardBannerAdProps {}
export default function AdnuntiusLeaderboardBannerAd({}: AdnuntiusLeaderboardBannerAdProps) {
  return (
    <AlignedCenter>
      <div
        id="adn-5bf48"
        style={{
          display: 'none',
        }}
        className={styles.adnLeaderboardBanner}
      ></div>
      <Script
        dangerouslySetInnerHTML={{
          __html: `
            window.adn = window.adn || {}; adn.calls = adn.calls || []; adn.calls.push(function() { adn.request({ network: '57ff2', adUnits: [ {auId: '5bf48', auW: 728, auH: 90 } ]}); });
          `,
        }}
      />
    </AlignedCenter>
  );
}
